import { EncodedDrawAction } from '@engoo/realtime-protocol/draw';
import { drawReducer, DrawState } from 'app/models/rtc/draw/reducer';
import { DummyLazyDocumentManager, ILazyDocumentManager, ILazyActionHandler } from 'app/services/rtc/sync/documentmanagers/lazy';
import { IDocumentSpec, IDocumentManagerFactory } from 'app/services/rtc/sync/DocumentSpec';
import { tFunctionType } from 'app/services/localization';
import { Stream } from '@engoo/realtime-protocol/stream';
import { IDocumentIndex } from 'app/services/rtc/constants';

export type DrawDocumentManager = ILazyDocumentManager<DrawState, EncodedDrawAction>;

export type DrawDocumentSpec = IDocumentSpec<
  DrawState,
  EncodedDrawAction,
  ILazyActionHandler<DrawState, EncodedDrawAction>,
  DrawDocumentManager
>;

interface IMakeDrawDocumentSpecOptions {
  managerType: IDocumentManagerFactory<
    DrawState,
    EncodedDrawAction,
    ILazyActionHandler<DrawState, EncodedDrawAction>,
    DrawDocumentManager
  >;
  actionHandler: ILazyActionHandler<DrawState, EncodedDrawAction>;
}

/**
 * We need to be able to provide instance of the DrawActionHandler
 * in the context, hence the document spec needs to be generate
 * dynamically.
 */
export const makeDrawDocumentSpec = ({
  actionHandler,
  managerType,
}: IMakeDrawDocumentSpecOptions): DrawDocumentSpec => ({
  actionHandler,
  managerType,
  initialState: drawReducer(),
  name: (t: tFunctionType) => t('rtc.features.draw.name'),
});

/**
 * This is only used for BlockedStreamsErrorMessage component so
 * needs to only expose name name and type
 */
export const dummyDrawDocumentSpec: IDocumentIndex = {
  [Stream.Draw]: makeDrawDocumentSpec({
    managerType: DummyLazyDocumentManager,
    actionHandler: { apply: (state) => state, compress: () => [] },
  }),
};
